import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=4fd998ea&scoped=true&lang=html"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd998ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fd998ea')) {
      api.createRecord('4fd998ea', component.options)
    } else {
      api.reload('4fd998ea', component.options)
    }
    module.hot.accept("./AboutUs.vue?vue&type=template&id=4fd998ea&scoped=true&lang=html", function () {
      api.rerender('4fd998ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AboutUs.vue"
export default component.exports